import { render, staticRenderFns } from "./BindSupplierDialog.vue?vue&type=template&id=6dba9c9c&scoped=true"
import script from "./BindSupplierDialog.vue?vue&type=script&lang=js"
export * from "./BindSupplierDialog.vue?vue&type=script&lang=js"
import style0 from "./BindSupplierDialog.vue?vue&type=style&index=0&id=6dba9c9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba9c9c",
  null
  
)

export default component.exports